module.exports = __webpack_public_path__ + "img/icon--chevron-left.cf0378bc.svg";